<template>
    <div id="activities-page">
        <ActivitySidebar :filter="filter" @filtered="updateFilters" />
        <div class="page-content" ref="container">
            <div class="page-content-wrapper">
                <header>{{ $t('notification.activities') }}</header>
                <ActivityListView :activities="activities" :loading="loading" @load-more="loadMore" />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import ActivitySidebar from "./ActivitySidebar.vue";
import ActivityListView from "./ActivityListView.vue";
import { ACTIVITY_API } from "../../../api/activity";

export default Vue.extend({
    name: "Activities",
    components: { ActivityListView, ActivitySidebar },
    data() {
        return {
            filter: {
                actorIds: [],
                startDate: null,
                endDate: null,
                activityTypes: [],
            },
            loading: false,
            activities: [],
            total: 0,
            cursor: {
                page: 1,
                perPage: 50,
            },
        };
    },
    methods: {
        updateFilters(filter) {
            this.filter = filter;
        },
        fetchActivities(pagination) {
            this.loading = true;
            ACTIVITY_API.ACTIVITY.list(this.cursor, this.filter)
                .then((res) => {
                    const { count, items } = res.data;
                    this.activities = _.uniqBy(pagination ? [...this.activities, ...items] : items, (q) => q._id);
                    this.total = count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goBack() {
            this.$router.back();
        },
        loadMore() {
            if (Math.ceil(this.total / this.cursor.perPage) > this.cursor.page) {
                this.cursor.page = this.cursor.page + 1;
            }
        },
    },
    mounted() {
        this.fetchActivities();
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                this.fetchActivities();
            },
        },
        cursor: {
            deep: true,
            handler() {
                this.fetchActivities(true);
            },
        },
    },
});
</script>

<style scoped lang="scss">
#activities-page {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    background-color: var(--color-bg-default);
    font-size: 14px;
    font-weight: 400;
    color: var(--color-text-default);
    line-height: 24px;

    .page-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 100%;
        position: relative;
        padding: 20px;
        overflow-y: auto;
        height: calc(100vh - 93px);
        max-height: 100%;

        .page-content-wrapper {
            max-width: 1000px;
            width: 100%;
            margin: 0 auto;

            header {
                font-weight: 700;
                color: var(--color-text-strong-default);
                font-size: 18px;
            }

            .group {
                .date {
                    position: relative;
                    display: inline;

                    &:after {
                        position: absolute;
                        left: 50%;
                        bottom: -15px;
                        height: 12px;
                        width: 1px;
                        content: "";
                        background: var(--color-border-default);
                    }
                }

                .items {
                    display: flex;
                    flex-direction: column;
                    border: 1px solid var(--color-border-default);
                    border-radius: 4px;
                    margin-top: 11px;

                    .activity-card:last-child {
                        border-bottom: none;
                    }

                    .activity-card {
                        display: flex;
                        justify-content: space-between;
                        border-bottom: 1px solid var(--color-border-default);
                        background-color: var(--color-bg-default);
                        padding: 20px;
                        border-radius: 4px 4px 0 0;
                        cursor: pointer;

                        &.note {
                            .left {
                                .content {
                                    display: unset !important;
                                }
                            }
                        }

                        &.rating {
                            .left {
                                .content {
                                    gap: 3px;
                                    display: flex;
                                    align-items: center;
                                    flex-wrap: wrap;

                                    #rating-yes,
                                    #rating-strong-yes {
                                        width: 20px;
                                        height: 20px;
                                        fill: #1ab616;
                                    }

                                    #rating-not-sure {
                                        fill: #f09a0f;
                                        width: 20px;
                                        height: 20px;
                                    }

                                    #rating-no {
                                        fill: #e50101;
                                        width: 20px;
                                        height: 20px;
                                    }
                                }
                            }
                        }

                        .quote {
                            padding-left: 8px;
                            border-left: 2px solid var(--color-border-default);
                            font-style: italic;
                            line-height: 24px;
                            display: block;
                        }

                        .tag {
                            background-image: var(--color-bg-default);
                            border: 1px solid var(--color-border-default);
                            line-height: 20px;
                            padding: 0 8px;
                            border-radius: 4px;
                            cursor: inherit;
                            display: inline-block;
                            color: var(--color-text-default);
                            font-size: 14px;
                            font-weight: 600;
                            position: relative;
                            margin-left: 5px;
                        }

                        .left {
                            display: flex;
                            gap: 10px;
                            align-items: center;

                            .avatar-wrapper {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                position: relative;

                                .icon {
                                    display: flex;
                                    width: 24px;
                                    height: 24px;
                                    border-radius: 50%;
                                    position: absolute;
                                    align-content: center;
                                    align-items: center;
                                    justify-content: center;

                                    right: -8px;
                                    bottom: -8px;
                                    background-color: var(--color-bg-default);
                                    color: var(--color-icon-default);

                                    .MuiSvgIcon-root {
                                        color: var(--color-icon-default);
                                        width: 18px;
                                        height: 18px;
                                    }

                                    svg.text-danger {
                                        fill: var(--color-bg-critical-default) !important;
                                    }

                                    svg.text-success {
                                        fill: var(--color-bg-success-default) !important;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
